import {
  FaReact,
  FaHtml5,
  FaCss3Alt,
  FaGithub,
  FaMdb,
  FaNodeJs,
} from "react-icons/fa";
import {
  SiPostman,
  SiMongodb,
  SiGnubash,
  SiJavascript,
  SiExpress,
  SiAdobeillustrator,
  SiAdobephotoshop,
  SiUnity,
  SiAdobepremierepro,
  SiAdobexd,
} from "react-icons/si";

const aboutData = {
  skillData: [
    {
      icon: <FaReact />,
      name: "React.js",
      badge: "Professional",
      color: `primary`,
      barWidth: 80,
    },
    {
      icon: <FaHtml5 />,
      name: "Html5",
      badge: "Expert",
      color: "danger",
      barWidth: 90,
    },
    {
      icon: <SiPostman />,
      name: "Postman",
      badge: "Competent",
      color: "success",
      barWidth: 70,
    },
    {
      icon: <FaCss3Alt />,
      name: "CSS",
      badge: "Professional",
      color: "primary",
      barWidth: 80,
    },
    {
      icon: <FaMdb />,
      name: "MDBbootstrap",
      badge: "Competent",
      color: "success",
      barWidth: 70,
    },
    {
      icon: <SiMongodb />,
      name: "MongoDB",
      badge: "Competent",
      color: "success",
      barWidth: 70,
    },
    {
      icon: <SiJavascript />,
      name: "Javascript",
      badge: "Professional",
      color: "primary",
      barWidth: 80,
    },
    {
      icon: <FaGithub />,
      name: "Github",
      badge: "Competent",
      color: "success",
      barWidth: 70,
    },
    {
      icon: <SiGnubash />,
      name: "Bash",
      badge: "Basic",
      color: "warning",
      barWidth: 60,
    },
    {
      icon: <SiExpress />,
      name: "Express.js",
      badge: "Professional",
      color: "primary",
      barWidth: 80,
    },
    {
      icon: <FaNodeJs />,
      name: "Node.js",
      badge: "Professional",
      color: "primary",
      barWidth: 80,
    },
    {
      icon: <SiAdobeillustrator />,
      name: "Adobe Illustrator",
      badge: "Skilled",
      color: "success",
      barWidth: 70,
    },
    {
      icon: <SiAdobephotoshop />,
      name: "Adobe Photoshop",
      badge: "Professional",
      color: "primary",
      barWidth: 80,
    },
    {
      icon: <SiUnity />,
      name: "Unity 3D",
      badge: "Basic",
      color: "warning",
      barWidth: 60,
    },
    {
      icon: <SiAdobepremierepro />,
      name: "Adobe Premiere Pro",
      badge: "Professional",
      color: "primary",
      barWidth: 80,
    },
    {
      icon: <SiAdobexd />,
      name: "Adobe XD",
      badge: "Skilled",
      color: "success",
      barWidth: 70,
    },
  ],
  eduData: [
    {
      color: "table-success",
      standard: "B.Sc.(H) Computer Science",
      year: "2019-22",
      name: "Hansraj College, University of Delhi",
      score: "7.67 CGPA",
    },
    {
      color: "table-primary",
      standard: "TSBIE (Class XII)",
      year: "2017-2019",
      name: "SR Junior College, Warangal, Telangana",
      score: "96%",
    },
    {
      color: "table-light",
      standard: "TCSSC (Class X)",
      year: "2017",
      name: "Maatrusri High School, Warangal, Telangana",
      score: "8.7 CGPA / 82.65%",
    },
  ],
};

export default aboutData;
